'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const withStyledThemeProvider = (component, options) => {
  const {
    themeTokens,
    customMapper
  } = options;
  const HoC = /*#__PURE__*/React__default["default"].forwardRef((props, ref) => {
    const theme = nthHookTheme.useTheme();
    let styledTheme = {};
    themeTokens.forEach(token => {
      styledTheme[token] = theme[token];
    });
    if (customMapper) {
      styledTheme = customMapper(styledTheme);
    }
    return /*#__PURE__*/React__default["default"].createElement(styled.ThemeProvider, {
      theme: styledTheme
    }, /*#__PURE__*/React__default["default"].createElement(component, {
      ...props,
      ref
    }));
  });
  const name = component.displayName ?? component.name;
  HoC.displayName = `WithStyledThemeProvider(${name})`;
  return nthHookTheme.withThemeProvider(HoC, {
    themeTokens
  });
};

exports.withStyledThemeProvider = withStyledThemeProvider;
